import { FaHome, FaQuestionCircle, FaUser, FaUserCircle } from "react-icons/fa";
import { HomeLink, NavLink } from "./Elements";
import { FaBriefcase, FaImages, FaVideo, FaYoutube } from "react-icons/fa6";

export const Links = () => (
  <>
    <NavLink href="/" icon={FaHome}>
      Home
    </NavLink>
    <NavLink href="/#/about" icon={FaUser}>
      About
    </NavLink>
    <NavLink href="/v" icon={FaYoutube}>
      Videos
    </NavLink>
    <NavLink href="/thumbnails" icon={FaImages}>
      Thumbnails
    </NavLink>
    <NavLink href="/clients" icon={FaUserCircle}>
      Clients
    </NavLink>
    <NavLink href="/faq" icon={FaQuestionCircle}>
      FAQ
    </NavLink>
    <NavLink href="/jobs" icon={FaBriefcase} className="hidden">
      Jobs (beta)
    </NavLink>
  </>
);
